import React from "react";
import { useNavigate } from "react-router";
import { useRecommendedPathForUser } from "src/ui/navigation/dashboardRouting/useRecommendedPathForUser";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
    link: {
        display: "inline-flex",
        alignItems: "center",
    },
});

export const DrawerLogoLink = (props: React.PropsWithChildren<object>) => {
    const navigate = useNavigate();
    const { path: recommendedPath, isLoading } = useRecommendedPathForUser();
    const { classes } = useStyles();

    return (
        <a
            className={classes.link}
            href={isLoading ? "#" : recommendedPath}
            onClick={(e) => {
                e.preventDefault();
                if (isLoading) {
                    return;
                }
                void navigate(recommendedPath);
            }}
        >
            {props.children}
        </a>
    );
};
